import { initSentry } from '@imt/vue-toolbox/src/plugins/sentry';
import * as Sentry from '@sentry/vue';
import Vue from 'vue';

initSentry({
    Vue,
    dsn: 'https://a89ea827a1f041d9a9968ac53a3b2b29@o527262.ingest.sentry.io/5658864',
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.vueIntegration({
            tracingOptions: {
                trackComponents: true,
            },
        }),
    ],
    tracesSampleRate: 1.0,
});
